// extracted by mini-css-extract-plugin
export default {"rating":"hK-z","numberOfStars":"iK-z","count":"jK-z","barGraphSpacing":"kK-z","barGraph":"lK-z"};